import { Control, Controller } from "react-hook-form";
import { Tool } from "../AssistantDetailsContent";
import { ActionsField } from "../ActionsField";

export const ActionsFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const value = field.value as Tool[] | undefined;
        return (
          <ActionsField
            tools={value}
            onToolsChange={field.onChange}
            isDisabled={isDisabled}
          />
        );
      }}
    />
  );
};
